import React from 'react';
// no direct MUI props needed here
import type { To } from 'react-router-dom';
import { BaseButton, type BaseButtonProps } from './BaseButton';

// Intentionally not exporting a standalone color union here; use BaseButtonProps['color'] for consistency.

export type LinkButtonProps = {
  /** Visual style */
  variant?: BaseButtonProps['variant'];
  /** Visual size */
  size?: BaseButtonProps['size'];
  /** Color palette */
  color?: BaseButtonProps['color'];
  /** Disabled state */
  disabled?: BaseButtonProps['disabled'];
  /** Button type attribute */
  type?: BaseButtonProps['type'];
  /** Optional start icon */
  startIcon?: BaseButtonProps['startIcon'];
  /** Optional end icon */
  endIcon?: BaseButtonProps['endIcon'];
  /** DOM id */
  id?: BaseButtonProps['id'];
  /** Button label/content */
  children: BaseButtonProps['children'];
  /** Full width */
  fullWidth?: BaseButtonProps['fullWidth'];
  /** Target route */
  to: To;
  /** Replace route when navigating */
  replace?: boolean;
  /** Open the route in a new browser tab */
  openInNewTab?: boolean;
};

export const LinkButton: React.FC<LinkButtonProps> = ({
  to,
  replace,
  openInNewTab,
  ...props
}) => (
  <BaseButton
    link={{
      to,
      replace,
      ...(openInNewTab ? { target: '_blank', rel: 'noopener noreferrer' } : {}),
    }}
    {...props}
  />
);
